export { default } from "./AdaptiveList";
